import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-6 w-[calc(100%+32px)] pb-6"
}
const _hoisted_2 = { class: "mx-6 mt-8 border rounded-lg border-neutral-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Report Type", -1)
const _hoisted_7 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_8 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_9 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Group", -1)
const _hoisted_11 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_12 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "CATEGORY", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_15 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "SEX", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Filter", -1)
const _hoisted_18 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Sort", -1)
const _hoisted_20 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_21 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_23 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_24 = { class: "space-y-5" }
const _hoisted_25 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_26 = {
  key: 0,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_27 = {
  key: 1,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_28 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_29 = {
  key: 2,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_30 = {
  key: 3,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_31 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_32 = {
  key: 4,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_33 = {
  key: 5,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_34 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_35 = {
  key: 6,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_36 = {
  key: 7,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_37 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_38 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_39 = { class: "bg-gray-50" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }, " Total ", -1)
const _hoisted_41 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_42 = {
  key: 0,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_43 = {
  key: 1,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_44 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_45 = {
  key: 2,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_46 = {
  key: 3,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_47 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_48 = {
  key: 4,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_49 = {
  key: 5,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_50 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_51 = {
  key: 6,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_52 = {
  key: 7,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_53 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_54 = {
  key: 8,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_55 = {
  key: 9,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_56 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_57 = {
  key: 10,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_58 = {
  key: 11,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_59 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_60 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_61 = { class: "bg-gray-50" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }, " Total ", -1)
const _hoisted_63 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, onMounted } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import DetailTable from '@/components/partials/DetailTable.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { AdjustmentsVerticalIcon, UserGroupIcon, FunnelIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/outline";
import { Popover, PopoverButton, PopoverPanel, Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';
import ReportService from '@/classes/Reports/ReportService'; 
 
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import debounce from "lodash/debounce";
import { ReportTypes } from '@/views/enums/ReportTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportCaseRelatedAgeGroup',
  setup(__props) {

const showFilter = ref<boolean>(false); 
const loading = ref<boolean>(false);
 
const groupCategoryOptions = [
    { id: 1, label: "CPN/Children", value: 1 },
    { id: 2, label: "UNICEF/Children", value: 2 },
    { id: 3, label: "Adult Patient", value: 3 },
]
const sortOptions = [
    { id: '1', label: 'Name', value: 'name'}, 
    { id: '2', label: 'Count', value: 'total'},
]
const orderOptions = [
    { id: '3', label: 'Ascending', value: 'asc'},
    { id: '4', label: 'Descending', value: 'desc'},
]

const sexOptions = [
    { id: "1", label: "All", value: 2 },
    { id: "2", label: "Male", value: 0 },
    { id: "3", label: "Female", value: 1 },
];


const reportTypeOptions = [
    { id: "1", label: "Primary Diagnosis", value: ReportTypes.PRIMARY_DIAGNOSIS },
    { id: "2", label: "Indigenous Group", value: ReportTypes.INDIGENOUS_GROUP },
    // { id: "3", label: "Comorbid VAC/VAW", value: 7 },
];
 

const headers = ref([
    { text: 'Barangay' },
    { text: '0-3' },
    { text: '4-6' },
    { text: '7-9' },
    { text: '10-12' },
    { text: '13-15' },
    { text: '16-18' },
    { text: 'Total' },
]);
const unicefHeaders = ref([
    { text: 'Barangay' },
    { text: '0-9' },
    { text: '10-14' },
    { text: '15-17' },
    { text: '18+' },
    { text: 'Total' },
]);

const adultHeaders = ref([
{ text: 'Barangay' },
    { text: '18-24' },
    { text: '25-44' },
    { text: '45-59' },
    { text: '60-100+' },
    { text: 'Total' },
]);

const Primaryheaders = ref([
    { text: 'Primary Diagnosis', colspan: 1, rowspan: 2 },
    { text: '0-3', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '4-6', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '7-9', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '10-12', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '13-15', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '16-18', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: 'Total', colspan: 1, rowspan: 2 }
]);

const PrimaryunicefHeaders = ref([
    { text: 'Primary Diagnosis', colspan: 1, rowspan: 2 },
    { text: '0-9', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '10-14', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '15-17', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '18+', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] }, 
    { text: 'Total', colspan: 1, rowspan: 2 } 
]);

const PrimaryadultHeaders = ref([
    { text: 'Primary Diagnosis', colspan: 1, rowspan: 2 },
    { text: '18-24', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '25-44', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '45-59', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] },
    { text: '60-100+', colspan: 3, rowspan: 1, subheaders: ['M', 'F', 'Total'] }, 
    { text: 'Total', colspan: 1, rowspan: 2 }  
]);

const filters = ref({
    page: 1,
    query: null,
    rows: 10,
    created_at: null,
    order: 'asc',
    column: 'name',
    report_type: ReportTypes.PRIMARY_DIAGNOSIS,
    group_category: 1,
    sex_at_birth: 2
})


const paginate = ( page:number, rows:number )=>{
    ReportService.paginate(page, rows,filters.value, fetch)
}

const applyFilters = () => {
	showFilter.value = false;
    paginate( 1, filters.value.rows);
};

const applyReset = () => {
    showFilter.value = false;
    filters.value.created_at = null; 
    paginate( 1, filters.value.rows);
};

const items = ref()
const totals = ref()

 
const fetch = () => { 
    loading.value = true;
    ReportService.index('case-related-age-group', omitBy(filters.value, isNil))
        .then(({ data }) => { 
            items.value = data.data 
            totals.value = data.totals  
            
            console.log(totals.value);
        })
        .catch(errors => { 
            console.log(errors);
        })
        .finally(() => loading.value = false)
}

const exporting = (): void => {
    loading.value = true;
    ReportService.export('case-related-age-group',omitBy(filters.value, isNil))
        .then(({data})=>{ 
             ReportService.downloadExport("case-related-age-group-export.csv",data);  
        })
        .finally(() => loading.value = false)
}
 
const getReportTypeHeader = (type: any)=>{
    reportTypeOptions.filter(function(item:any){
        if(item.value === type){
            headers.value[0].text = item.label;
            unicefHeaders.value[0].text = item.label
            adultHeaders.value[0].text = item.label
        } 
    });
} 

watch(
    () => filters.value.query,
    debounce(() => {
        paginate( 1, filters.value.rows);
        applyReset();
    }, 500)
);

watch(
    () => filters.value.report_type,
    debounce(() => {
        getReportTypeHeader(filters.value.report_type); 
    }, 500)
);

onMounted(()=> { 
    fetch();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Case Related Age Group Report",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      _createVNode(ExportButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exporting()))
      })
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DetailTable, {
                  hasSearch: true,
                  searchPlaceholder: "Search Report type name",
                  headers: 
                        filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS 
                        ? (filters.value.group_category == 1 ? Primaryheaders.value : (filters.value.group_category == 2 ? PrimaryunicefHeaders.value : PrimaryadultHeaders.value))
                        : filters.value.group_category == 1 ? headers.value : (filters.value.group_category == 2 ? unicefHeaders.value : adultHeaders.value)
                        ,
                  "no-action": true,
                  count: items.value?.data.length,
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  search: filters.value.query,
                  "onUpdate:searchText": _cache[16] || (_cache[16] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(AdjustmentsVerticalIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_6
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(RadioGroup, {
                                        options: reportTypeOptions,
                                        name: "reportTypeOptions",
                                        modelValue: filters.value.report_type,
                                        "onUpdate:modelValue": [
                                          _cache[1] || (_cache[1] = ($event: any) => ((filters.value.report_type) = $event)),
                                          _cache[2] || (_cache[2] = ($event: any) => (paginate(1, filters.value.rows)))
                                        ],
                                        customLabelClass: "whitespace-nowrap"
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_unref(UserGroupIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_10
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _hoisted_13,
                                      _createVNode(RadioGroup, {
                                        options: groupCategoryOptions,
                                        name: "categoryOptions",
                                        modelValue: filters.value.group_category,
                                        "onUpdate:modelValue": [
                                          _cache[3] || (_cache[3] = ($event: any) => ((filters.value.group_category) = $event)),
                                          _cache[4] || (_cache[4] = ($event: any) => (paginate( 1, 10)))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_14,
                                    _createElementVNode("div", _hoisted_15, [
                                      _hoisted_16,
                                      _createVNode(RadioGroup, {
                                        options: sexOptions,
                                        name: "sexOptions",
                                        modelValue: filters.value.sex_at_birth,
                                        "onUpdate:modelValue": [
                                          _cache[5] || (_cache[5] = ($event: any) => ((filters.value.sex_at_birth) = $event)),
                                          _cache[6] || (_cache[6] = ($event: any) => (paginate( 1, 10)))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (showFilter.value = true))
                      }, [
                        _createVNode(_unref(FunnelIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                        _hoisted_17
                      ]),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_unref(ArrowsUpDownIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_19
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                      _createVNode(RadioGroup, {
                                        options: sortOptions,
                                        modelValue: filters.value.column,
                                        "onUpdate:modelValue": [
                                          _cache[8] || (_cache[8] = ($event: any) => ((filters.value.column) = $event)),
                                          _cache[9] || (_cache[9] = ($event: any) => (fetch()))
                                        ],
                                        name: "sortOptions"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_22,
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(RadioGroup, {
                                        options: orderOptions,
                                        modelValue: filters.value.order,
                                        "onUpdate:modelValue": [
                                          _cache[10] || (_cache[10] = ($event: any) => ((filters.value.order) = $event)),
                                          _cache[11] || (_cache[11] = ($event: any) => (fetch()))
                                        ],
                                        name: "orderOptions"
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[13] || (_cache[13] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[14] || (_cache[14] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[15] || (_cache[15] = ($event: any) => (applyFilters())),
                        customClass: "!overflow-visible overflow-x-visible"
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(DatePicker, {
                              id: "date_created",
                              name: "date_created",
                              label: "Date Created",
                              modelValue: filters.value.created_at,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.value.created_at) = $event)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (filters.value.group_category !== 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_25, _toDisplayString(item.name), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(item.male_set1), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(item.female_set1), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_28, _toDisplayString(item.set1), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(item.male_set2), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(item.female_set2), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_31, _toDisplayString(item.set2), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(item.male_set3), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(item.female_set3), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_34, _toDisplayString(item.set3), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(item.male_set4), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(item.female_set4), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(item.set4), 1),
                              _createElementVNode("td", _hoisted_38, _toDisplayString(item.total), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_39, [
                            _hoisted_40,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (total, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: index,
                                class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap"
                              }, _toDisplayString(total), 1))
                            }), 128))
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
                            return (_openBlock(), _createElementBlock("tr", { key: item }, [
                              _createElementVNode("td", _hoisted_41, _toDisplayString(item.name), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(item.male_set1), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(item.female_set1), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(item.set1), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(item.male_set2), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(item.female_set2), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(item.set2), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_48, _toDisplayString(item.male_set3), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_49, _toDisplayString(item.female_set3), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(item.set3), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_51, _toDisplayString(item.male_set4), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(item.female_set4), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(item.set4), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(item.male_set5), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(item.female_set5), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_56, _toDisplayString(item.set5), 1),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(item.male_set6), 1))
                                : _createCommentVNode("", true),
                              (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(item.female_set6), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_59, _toDisplayString(item.set6), 1),
                              _createElementVNode("td", _hoisted_60, _toDisplayString(item.total), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", _hoisted_61, [
                            _hoisted_62,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (total, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: index,
                                class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap"
                              }, _toDisplayString(total), 1))
                            }), 128))
                          ])
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["headers", "count", "search"]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(SimplePagination, {
                    numRows: filters.value.rows ?? 10,
                    currentPage: items.value?.current_page,
                    "last-page": items.value?.last_page,
                    onUpdate: _cache[17] || (_cache[17] = (value) => paginate(value.page, value.rows))
                  }, null, 8, ["numRows", "currentPage", "last-page"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoadingModal, {
        show: loading.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})